import { c as _c } from "react/compiler-runtime";
import { NewsCarousel } from '@/app/lcv/components/sections/news-activities/news-carousel';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import type { LcvNewsDetail } from '@/types/tis-cms/types';
export const NewsRelated = t0 => {
  const $ = _c(6);
  const {
    data: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: "news-related"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="font-display text-h2 mb-6 sm:mb-10" {...createDataAttributes({
      test: "heading-lead"
    })}>ข่าวสารและกิจกรรมที่เกี่ยวข้อง</h2>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== data) {
    t5 = <div className="relative pt-0!" {...t3}>{t4}<NewsCarousel data={data} /></div>;
    $[4] = data;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};